export class NodePendingQueue {
  private _tasks: (() => void)[] = [];

  constructor() {
    if (typeof window === 'undefined') {
      setInterval(this._doInterval, 500);
    }
  }

  public push(task: (...args: unknown[]) => void) {
    if (typeof window === 'undefined') {
      this._tasks.push(task);
    }
  }

  private _doInterval = (): void => {
    if (this._tasks.length) {
      console.log('pending tasks found, total count: %d', this._tasks.length);
      this._tasks.forEach((task) => task());
      this._tasks = [];
    }
  };
}

export const nodePendingQueue = new NodePendingQueue();
